import {select} from "../../store";
import {ADMISSION_EXPIRED_SESSION_ROUTE} from "../../pages/page-admission-expired-session/route";
import {createRouteGuard} from "../../routers/createRouteGuard";

export const TokenIsNotExpired = createRouteGuard({
  authenticatedSelector: state =>
    !select.admissionSession.tokenIsExpired(state),
  redirectPath: ADMISSION_EXPIRED_SESSION_ROUTE,
});
